import Util from "../utils/Util";
import { api } from "./api";

class SubscriptionService {
  async findByConnectId(connectId) {
    var retorno = "";
    try {
      retorno = await api.get("/cloudplus/subscriptions/connect?connectId=" + connectId, Util.getTokenAPIBackEnd());
      return retorno.data;
    } catch (error) {
      return null;
    }
  }

}

const subscriptionService = new SubscriptionService();
export default subscriptionService;